import {AuthImagePipe} from "./pipes/auth-image-pipe";

export {
  AuthImagePipe
}
